<template>
  <ion-page>
    <ion-header class="ion-no-border" translucent>
      <ion-toolbar class="-not-fixed">
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text="">
          </back-button>
        </ion-buttons>
        <ion-button
          @click="$store.commit('setOpenMenu', true)"
          slot="end"
          fill="clear"
          size="large"
          ><ion-icon
            slot="icon-only"
            :src="require('@lib/assets/icons/menu.svg')"
            size="large"></ion-icon
        ></ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen class="ion-padding">
      <ion-grid>
        <h1>Geteilten Roodie.Check herunterladen</h1>
        <ion-item lines="none" class="ion-margin-top">
          <ion-input
            placeholder="Passwort"
            v-model="Password"
            @keyup.enter="submit()"></ion-input>
        </ion-item>
        <input-error id="Password" />
        <div class="ion-text-center ion-margin-top">
          <ion-button @click="submit()"> Herunterladen </ion-button>
        </div>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import InputError from "@/components/InputError.vue";
import axios from "@/plugins/axios";
import { FileOpener } from "@awesome-cordova-plugins/file-opener";
import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonPage,
  IonToolbar,
  IonBackButton,
} from "@ionic/vue";
import { chevronBack } from "ionicons/icons";
import { appOrigin } from "@/utils/basics";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonContent,
    IonButton,
    IonIcon,
    IonGrid,
    IonInput,
    IonItem,
    InputError,
    IonBackButton,
  },
  data() {
    return {
      Password: "",
    };
  },
  methods: {
    async submit() {
      this.$store.commit("setShowLoading", true);
      const response = await axios.post(
        "?Mode=General&Function=GetDownloadUrlForSharedRoodieCheck",
        {
          Token: this.$route.query.Token,
          Password: this.Password,
        }
      );
      if (response.data.Status === "Success") {
        if (Capacitor.isNativePlatform()) {
          this.$store.commit("setShowLoading", true);
          const downloadResponse = await axios.get(
            appOrigin + response.data.Result + "&Base64=true"
          );
          this.$store.commit("setShowLoading", true);
          const writeFileResult = await Filesystem.writeFile({
            path: "Roodie_Check.pdf",
            data: downloadResponse.data,
            directory: Directory.External,
            // encoding: Encoding.UTF8,
          });
          await FileOpener.open(writeFileResult.uri, "application/pdf");
          this.$store.commit("setShowLoading", false);
        } else {
          window.open(appOrigin + response.data.Result, "_blank");
        }
      }
    },
  },
  setup() {
    return { chevronBack };
  },
};
</script>

<style lang="scss" scoped></style>
